// HelpFormFields.tsx
import React from 'react';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
} from '@mui/material';

const HelpFormFields = ({
  formData,
  handleInputChange,
  emailError,
  helpOptions,
  sizes,
  commonStyles,
}: any) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: sizes.spacing.lg }}>
    <Typography
      variant="body1"
      sx={{
        ...commonStyles.descriptionText,
        maxWidth: 'none',
        marginBottom: sizes.spacing.md,
      }}
    >
      Please fill out the form below and we'll get back to you as soon as
      possible.
    </Typography>
    <FormControl fullWidth required>
      <InputLabel>How can we assist you?</InputLabel>
      <Select
        value={formData.selectedOption}
        onChange={handleInputChange('selectedOption')}
        label="How can we assist you?"
        sx={{ borderRadius: sizes.borderRadius.medium }}
      >
        <MenuItem value="" disabled>
          Please select an option
        </MenuItem>
        {helpOptions.map((option: any) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    <TextField
      label="Full Name"
      value={formData.name}
      onChange={handleInputChange('name')}
      fullWidth
      required
      sx={{
        '& .MuiOutlinedInput-root': { borderRadius: sizes.borderRadius.medium },
      }}
    />
    <TextField
      label="Email Address"
      type="email"
      value={formData.email}
      onChange={handleInputChange('email')}
      fullWidth
      required
      error={!!emailError}
      helperText={emailError || ''}
      sx={{
        '& .MuiOutlinedInput-root': { borderRadius: sizes.borderRadius.medium },
      }}
    />
    <TextField
      label="Phone Number"
      value={formData.phone}
      onChange={handleInputChange('phone')}
      fullWidth
      sx={{
        '& .MuiOutlinedInput-root': { borderRadius: sizes.borderRadius.medium },
      }}
    />
    <TextField
      label="Additional Details"
      value={formData.moreDetails}
      onChange={handleInputChange('moreDetails')}
      fullWidth
      multiline
      minRows={4}
      sx={{
        '& .MuiOutlinedInput-root': { borderRadius: sizes.borderRadius.medium },
      }}
    />
  </Box>
);

export default HelpFormFields;
